import { defineMessages } from 'react-intl';

export default defineMessages({
	feedbackPreambleTitleText: {
		defaultMessage: '<p>Your thoughts are valuable in helping improve our products.</p>{br}',
		description: 'Introductory preamble text shown at the top of the product feedback form',
		id: 'sd.feedback.collector.feedback.preamble.title.text',
	},
	feedbackPreambleTitleTextAppify: {
		defaultMessage: '<p>Your thoughts are valuable in helping improve our apps.</p>{br}',
		description: 'Introductory preamble text shown at the top of the apps feedback form',
		id: 'sd.feedback.collector.feedback.preamble.title.text-appify',
	},
	canContactLabelText: {
		defaultMessage: 'Atlassian can contact me about this feedback. See our <a>privacy policy</a>',
		description: 'Checkbox label allowing Atlassian to contact the user about their feedback',
		id: 'sd.feedback.collector.can.contact.label.text',
	},
	enrolLabelText: {
		defaultMessage:
			"I'd like to help improve Atlassian products by joining the <a>Atlassian Research Group</a>",
		description: 'Checkbox label inviting user to join the Atlassian Research Group for products',
		id: 'sd.feedback.collector.enrol.label.text',
	},
	enrolLabelTextAppify: {
		defaultMessage:
			"I'd like to help improve Atlassian apps by joining the <a>Atlassian Research Group</a>",
		description: 'Checkbox label inviting user to join the Atlassian Research Group for apps',
		id: 'sd.feedback.collector.enrol.label.text-appify',
	},
	feedbackTitle: {
		defaultMessage: 'Share your thoughts',
		description: 'Heading displayed at the top of the feedback collector dialog',
		id: 'sd.feedback.collector.feedback.title',
	},
	summaryPlaceholder: {
		defaultMessage: "Let us know what's on your mind",
		description: 'Placeholder text shown in the feedback summary input field before user types',
		id: 'sd.feedback.collector.summary.placeholder',
	},
	questionSelectOptionLabel: {
		defaultMessage: 'Ask a question',
		description: 'Select option label for Question',
		id: 'sd.feedback.collector.question.select.option.label',
	},
	questionFieldLabel: {
		defaultMessage: 'What would you like to know?',
		description: 'Label to be shown when user chooses question from drop down',
		id: 'sd.feedback.collector.question.field.label',
	},
	commentSelectOptionLabel: {
		defaultMessage: 'Leave a comment',
		description: 'Select option label for Comment',
		id: 'sd.feedback.collector.comment.select.option.label',
	},
	commentFieldLabel: {
		defaultMessage: "Let us know what's on your mind",
		description: 'Label to be shown when user chooses comment from drop down',
		id: 'sd.feedback.collector.comment.field.label',
	},
	bugSelectOptionLabel: {
		defaultMessage: 'Report a bug',
		description: 'Dropdown option label for selecting to report a bug in the feedback form',
		id: 'sd.feedback.collector.bug.select.option.label',
	},
	bugFieldLabel: {
		defaultMessage: 'Describe the bug or issue',
		description: 'Label to be shown when user chooses bug from drop down',
		id: 'sd.feedback.collector.bug.field.label',
	},
	suggestionSelectOptionLabel: {
		defaultMessage: 'Suggest an improvement',
		description: 'Select option label for Suggestion',
		id: 'sd.feedback.collector.suggestion.select.option.label',
	},
	suggestionFieldLabel: {
		defaultMessage: "Let us know what you'd like to improve",
		description: 'Label to be shown when user chooses Suggestion from drop down',
		id: 'sd.feedback.collector.suggestion.field.label',
	},
	emptySelectOptionLabel: {
		defaultMessage: 'I want to...',
		description: 'Default dropdown option label shown before the user selects a feedback type',
		id: 'sd.feedback.collector.empty.select.option.label',
	},
	emptyFieldLabel: {
		defaultMessage: 'Select an option',
		description: 'Label to be shown when user chooses Empty from drop down',
		id: 'sd.feedback.collector.empty.field.label',
	},
	submitButtonLabel: {
		defaultMessage: 'Send feedback',
		description: 'Label on the submit button to send the completed feedback form',
		id: 'sd.feedback.collector.submit.button.label',
	},
	cancelButtonLabel: {
		defaultMessage: 'Cancel',
		description: 'Label on the cancel button to dismiss the feedback collector dialog',
		id: 'sd.feedback.collector.cancel.button.label',
	},
	feedbackSentFlagTitle: {
		defaultMessage: 'Thanks',
		description: 'Title of the confirmation flag shown after feedback has been submitted',
		id: 'sd.feedback.collector.feedback.sent.flag.title',
	},
	feedbackSentFlagDescription: {
		defaultMessage: 'Your valuable feedback helps us continually improve our products.',
		description: 'Body text of the confirmation flag shown after product feedback is submitted',
		id: 'sd.feedback.collector.feedback.sent.flag.description',
	},
	feedbackSentFlagDescriptionAppify: {
		defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
		description: 'Body text of the confirmation flag shown after apps feedback is submitted',
		id: 'sd.feedback.collector.feedback.sent.flag.description-appify',
	},
});
